// Fictional company "Torbynka", an online marketplace. Monday after a weekend
// drop in orders. See README.md for the schema.
export default {
  id: 'data-analyst',
  occupationId: '66b280672a4e4285b87eb56b',
  occupationName: { en: 'Data analyst', ua: 'Дата-аналітик' },
  format: 'dashboard',
  title: { en: 'A day as a data analyst', ua: 'День дата-аналітика' },
  tagline: {
    en: 'Orders fell over the weekend and five people already know why. Find out who is right.',
    ua: 'Замовлення за вихідні впали, і п’ятеро вже знають чому. З’ясуй, хто правий.'
  },
  minutes: 10,
  intro: {
    en: 'You are the only analyst at "Torbynka", an online marketplace with 60 employees and 16 000 orders a week. It is Monday 06.10. Weekend orders are visibly down, the Android team shipped a release on Friday, marketing switched on a new ad creative, and the CEO has a board call at 15:00.',
    ua: 'Ти єдиний аналітик у «Торбинці», онлайн-маркетплейсі на 60 людей і 16 000 замовлень на тиждень. Понеділок, 06.10. Замовлення за вихідні помітно впали, Android-команда в п’ятницю випустила реліз, маркетинг увімкнув новий креатив, а в CEO о 15:00 дзвінок із правлінням.'
  },
  goal: {
    en: 'Find the real cause before someone acts on a wrong one, and say it in a sentence the board can use',
    ua: 'Знайти справжню причину раніше, ніж хтось почне діяти за хибною, і сказати її одним реченням для правління'
  },
  kpis: [
    { key: 'insight', label: { en: 'Insight', ua: 'Інсайти' }, start: 50 },
    { key: 'dq', label: { en: 'Data quality', ua: 'Якість даних' }, start: 60 },
    { key: 'stakeholders', label: { en: 'Stakeholder trust', ua: 'Довіра бізнесу' }, start: 60 }
  ],
  competencies: [
    {
      key: 'analysis',
      label: { en: 'Analysis', ua: 'Аналіз' },
      skill: { _id: '686282c1aa8e5a92e3bc14b6', name: 'Аналіз даних' }
    },
    {
      key: 'rigour',
      label: { en: 'Rigour', ua: 'Ретельність' },
      skill: { _id: '686282c1aa8e5a92e3bc1366', name: 'Критичне мислення' }
    },
    {
      key: 'communication',
      label: { en: 'Communication', ua: 'Комунікація' },
      skill: { _id: '686282c1aa8e5a92e3bc133c', name: 'Комунікативність' }
    },
    {
      key: 'prioritisation',
      label: { en: 'Prioritisation', ua: 'Пріоритизація' },
      skill: { _id: '686282c1aa8e5a92e3bc140a', name: 'Управління часом і розстановка пріоритетів' }
    },
    {
      key: 'judgement',
      label: { en: 'Judgement', ua: 'Виваженість' },
      skill: { _id: '686282c1aa8e5a92e3bc1369', name: 'Прийняття рішень' }
    }
  ],
  people: [
    {
      key: 'marketing',
      name: { en: 'Dmytro', ua: 'Дмитро' },
      role: { en: 'Marketing lead', ua: 'Керівник маркетингу' },
      initials: 'DM',
      color: '#d5921b'
    },
    {
      key: 'ceo',
      name: { en: 'Natalia', ua: 'Наталія' },
      role: { en: 'CEO', ua: 'CEO' },
      initials: 'NA',
      color: '#9c27b0'
    },
    {
      key: 'android',
      name: { en: 'Vira', ua: 'Віра' },
      role: { en: 'Android team lead', ua: 'Лід Android-команди' },
      initials: 'VI',
      color: '#30b0c7'
    },
    {
      key: 'product',
      name: { en: 'Oleh', ua: 'Олег' },
      role: { en: 'Product manager', ua: 'Продакт-менеджер' },
      initials: 'OL',
      color: '#19857b'
    },
    {
      key: 'finance',
      name: { en: 'Larysa', ua: 'Лариса' },
      role: { en: 'Finance manager', ua: 'Фінансова менеджерка' },
      initials: 'LA',
      color: '#e25510'
    }
  ],
  steps: [
    {
      type: 'numeric',
      id: 's1',
      at: '09:00',
      comp: ['analysis', 'rigour'],
      traits: ['I', 'C'],
      text: {
        en: 'First thing Monday: weekend orders are down and three people have already asked why. Start with the number everyone will argue about.',
        ua: 'Перше в понеділок: замовлення за вихідні впали, і троє вже спитали чому. Почни з цифри, про яку всі сперечатимуться.'
      },
      data: [
        { label: { en: 'Sessions, Sat–Sun', ua: 'Сесії, сб–нд' }, value: '84 000' },
        { label: { en: 'Orders, Sat–Sun', ua: 'Замовлення, сб–нд' }, value: '2 310' },
        {
          label: { en: 'Sessions, previous weekend', ua: 'Сесії, минулі вихідні' },
          value: '84 000'
        },
        {
          label: { en: 'Orders, previous weekend', ua: 'Замовлення, минулі вихідні' },
          value: '2 570'
        }
      ],
      question: {
        en: 'What was this weekend’s conversion rate, in %?',
        ua: 'Яка конверсія за ці вихідні, у %?'
      },
      answer: 2.75,
      tolerance: 0.03,
      unit: { en: '%', ua: '%' },
      hint: {
        en: 'Conversion is orders divided by sessions. Then compare it with the previous weekend.',
        ua: 'Конверсія — це замовлення, поділені на сесії. Потім порівняй із минулими вихідними.'
      },
      explain: {
        en: '2 310 ÷ 84 000 = 2.75%, against 2 570 ÷ 84 000 = 3.06% a week earlier. Sessions did not move at all, so the whole 10% drop in orders is conversion, not traffic. That already rules out half the theories.',
        ua: '2 310 ÷ 84 000 = 2,75% проти 2 570 ÷ 84 000 = 3,06% тижнем раніше. Сесії не зрушили взагалі, тож усе падіння замовлень на 10% — це конверсія, а не трафік. Це вже відкидає половину теорій.'
      },
      fx: { ok: { insight: 5 }, fail: { insight: -4 } }
    },
    {
      type: 'choice',
      id: 's2',
      at: '09:30',
      comp: ['analysis', 'judgement'],
      traits: ['I', 'E'],
      text: {
        en: 'You cut the weekend by platform. Android orders −22%, iOS −3%, web −2%. Android app 5.8 shipped on Friday at 18:00. Ad spend was unchanged and the usual Saturday promo email went out on time.',
        ua: 'Ти розрізав вихідні за платформами. Замовлення на Android −22%, iOS −3%, веб −2%. Android-застосунок 5.8 вийшов у п’ятницю о 18:00. Витрати на рекламу не змінювалися, звична суботня промо-розсилка пішла вчасно.'
      },
      prompt: { en: 'What do you do with this?', ua: 'Що з цим робиш?' },
      options: [
        {
          text: {
            en: 'Isolate the release: compare Android conversion for users on 5.8 against users still on 5.7 over the same hours, and send Vira the first cut before anyone blames marketing.',
            ua: 'Ізолювати реліз: порівняти конверсію Android у користувачів на 5.8 і тих, хто ще на 5.7, за ті самі години, і скинути Вірі перший зріз, перш ніж хтось звинуватить маркетинг.'
          },
          q: 'best',
          fx: { insight: 6, stakeholders: 3 },
          fb: {
            en: 'One platform fell, one platform changed, and the timing matches. Version against version is the test that turns a strong suspicion into a cause.',
            ua: 'Одна платформа впала, одна платформа змінилася, і час збігається. Порівняння версії з версією перетворює сильну підозру на причину.'
          }
        },
        {
          text: {
            en: 'Build the full funnel by platform and hour for the whole week, check every step from home screen to payment, and present the complete picture at Tuesday’s sync.',
            ua: 'Побудувати повну воронку за платформами й годинами за весь тиждень, перевірити кожен крок від головного екрана до оплати й показати повну картину на вівторковому синку.'
          },
          q: 'ok',
          fx: { insight: 2, energy: -6, stakeholders: -2 },
          fb: {
            en: 'Thorough and a day late. If the release is the cause, every hour without a hotfix costs orders, and the funnel can be filled in after the first answer.',
            ua: 'Ретельно й на день пізно. Якщо причина в релізі, кожна година без хотфіксу коштує замовлень, а воронку можна добудувати після першої відповіді.'
          }
        },
        {
          text: {
            en: 'Tell Dmytro the Saturday promo email underperformed: orders fell on every platform, and the email is the only thing that touched all of them this weekend.',
            ua: 'Сказати Дмитру, що суботня промо-розсилка спрацювала слабко: замовлення впали на всіх платформах, а розсилка — єдине, що цих вихідних торкнулося всіх.'
          },
          q: 'bad',
          fx: { insight: -6, stakeholders: -4 },
          fb: {
            en: 'A 2–3% wobble on iOS and web is weekend noise; the −22% is not. You blamed the thing that touched everyone for a drop that hit one platform.',
            ua: 'Коливання 2–3% на iOS і вебі — це шум вихідних; −22% — ні. Ти звинуватив те, що торкнулося всіх, у падінні, яке вдарило по одній платформі.'
          }
        },
        {
          text: {
            en: 'Wait for Monday and Tuesday data: weekends are noisy, one bad weekend is not a trend, and raising an alarm now would only start a blame game.',
            ua: 'Дочекатися даних за понеділок і вівторок: вихідні шумні, одні погані вихідні — не тренд, а тривога зараз лише запустить пошук винних.'
          },
          q: 'bad',
          fx: { insight: -5, stakeholders: -5 },
          fb: {
            en: 'Noise does not pick one platform and one release date. Two more days of waiting is two more days of Android users not ordering.',
            ua: 'Шум не обирає одну платформу й одну дату релізу. Ще два дні очікування — ще два дні, коли користувачі Android не замовляють.'
          },
          later: {
            after: 2,
            note: {
              en: 'Vira found the bug herself an hour later: the new checkout button did not respond on older Android phones. She asks why analytics had not flagged it first.',
              ua: 'Віра знайшла баг сама за годину: нова кнопка оплати не реагувала на старих телефонах Android. Питає, чому аналітика не помітила першою.'
            },
            fx: { stakeholders: -5 }
          }
        }
      ],
      principle: { en: 'Segment first, then blame.', ua: 'Спочатку сегментуй, потім звинувачуй.' }
    },
    {
      type: 'chat',
      id: 's3',
      at: '10:15',
      comp: ['communication', 'rigour'],
      traits: ['S', 'E'],
      messages: [
        {
          from: 'marketing',
          text: {
            en: 'I saw iOS held up over the weekend. That is our new ad creative, we switched it on Friday. Can you send me a chart showing ads kept iOS stable? Natalia will love it.',
            ua: 'Бачив, що iOS на вихідних устояв. Це наш новий рекламний креатив, ми ввімкнули його в п’ятницю. Скинеш мені графік, що реклама втримала iOS? Наталії сподобається.'
          }
        },
        {
          from: 'marketing',
          text: {
            en: 'Nothing fancy, just iOS flat against Android down, with our launch date marked.',
            ua: 'Нічого складного, просто iOS рівно проти Android униз, і позначити дату нашого запуску.'
          }
        }
      ],
      prompt: { en: 'What do you reply?', ua: 'Що відповідаєш?' },
      options: [
        {
          text: {
            en: 'Tell him what the data shows: iOS also fell 3%, spend did not change and only Android got a release, so there is no evidence ads held anything. Offer the version-split chart instead.',
            ua: 'Сказати, що показують дані: iOS теж упав на 3%, витрати не змінювалися, а реліз отримав лише Android, тож доказів, що реклама щось втримала, немає. Запропонувати натомість графік у розрізі версій.'
          },
          q: 'best',
          fx: { stakeholders: 4, insight: 3 },
          fb: {
            en: 'He wanted a story; you gave him the real one with a chart he can still use. Marketing leads remember who told them the truth before the CEO asked.',
            ua: 'Він хотів історію; ти дав йому справжню з графіком, який він усе одно може використати. Керівники маркетингу пам’ятають, хто сказав правду до того, як спитала CEO.'
          }
        },
        {
          text: {
            en: 'Send the chart he describes with a footnote that the comparison is not causal and that iOS also dropped slightly, so he has the context if anyone asks.',
            ua: 'Надіслати графік, який він описує, із приміткою, що порівняння не доводить причину і що iOS теж трохи просів, щоб у нього був контекст, якщо хтось спитає.'
          },
          q: 'ok',
          fx: { stakeholders: 1, insight: -3 },
          fb: {
            en: 'Footnotes do not survive a slide deck. The chart will reach Natalia without the caveat, and your name will be on it.',
            ua: 'Примітки не переживають презентацію. Графік дійде до Наталії без застереження, і на ньому буде твоє ім’я.'
          }
        },
        {
          text: {
            en: 'Make the chart as asked: he knows the business better than you, the CEO wants some good news, and analysts who argue with every request stop getting invited.',
            ua: 'Зробити графік, як просять: він знає бізнес краще за тебе, CEO хоче хоч якихось добрих новин, а аналітиків, що сперечаються з кожним запитом, перестають кликати.'
          },
          q: 'bad',
          fx: { stakeholders: -6, insight: -5 },
          fb: {
            en: 'A chart that proves something false is the most expensive thing an analyst can make. When the release turns out to be the cause, the chart becomes the story.',
            ua: 'Графік, що доводить хибне, — найдорожче, що може зробити аналітик. Коли з’ясується, що причина в релізі, історією стане саме цей графік.'
          },
          later: {
            after: 2,
            note: {
              en: 'Natalia pasted Dmytro’s chart into the board deck. Vira’s hotfix note landed in the same thread an hour later.',
              ua: 'Наталія вставила графік Дмитра в презентацію для правління. Нотатка Віри про хотфікс з’явилася в тому самому треді на годину пізніше.'
            },
            fx: { stakeholders: -6 }
          }
        },
        {
          text: {
            en: 'Reply that analysts do not make charts to order and that he should ask the BI team for a self-serve dashboard, since you have a real investigation running.',
            ua: 'Відповісти, що аналітики не роблять графіки на замовлення і хай просить у BI-команди дашборд самообслуговування, бо в тебе триває справжнє розслідування.'
          },
          q: 'bad',
          fx: { stakeholders: -7 },
          fb: {
            en: 'He asked a bad question, not a rude one. Gatekeeping teaches him to stop asking you, which is how analysts end up answering nobody.',
            ua: 'Він поставив погане питання, а не грубе. Відмова з порога вчить його більше не питати тебе, і так аналітики лишаються без тих, кому відповідати.'
          }
        }
      ],
      principle: {
        en: 'Never make a chart you could not defend to the person it is about.',
        ua: 'Ніколи не роби графік, який не зміг би захистити перед тим, про кого він.'
      }
    },
    {
      type: 'numeric',
      id: 's4',
      at: '11:00',
      comp: ['analysis', 'rigour'],
      traits: ['I', 'C'],
      text: {
        en: 'Oleh wants to close the web checkout test today. It ran for a week with a 50/50 split; he asks how much the variant lifted conversion.',
        ua: 'Олег хоче сьогодні закрити тест нового веб-оформлення. Він тривав тиждень з розподілом 50/50; Олег питає, наскільки варіант підняв конверсію.'
      },
      data: [
        { label: { en: 'Control: sessions', ua: 'Контроль: сесії' }, value: '40 000' },
        { label: { en: 'Control: orders', ua: 'Контроль: замовлення' }, value: '1 240' },
        { label: { en: 'Variant: sessions', ua: 'Варіант: сесії' }, value: '40 000' },
        { label: { en: 'Variant: orders', ua: 'Варіант: замовлення' }, value: '1 364' }
      ],
      question: {
        en: 'What is the relative uplift in conversion, in %?',
        ua: 'Який відносний приріст конверсії, у %?'
      },
      answer: 10,
      tolerance: 0.05,
      unit: { en: '%', ua: '%' },
      hint: {
        en: 'Compute each group’s conversion, then the change as a share of the control’s rate.',
        ua: 'Порахуй конверсію кожної групи, потім зміну як частку від рівня контролю.'
      },
      explain: {
        en: 'Control: 1 240 ÷ 40 000 = 3.10%. Variant: 1 364 ÷ 40 000 = 3.41%. (3.41 − 3.10) ÷ 3.10 = 10% relative uplift, or 0.31 points. Say both numbers: "10%" alone sounds like 10 points to half the room.',
        ua: 'Контроль: 1 240 ÷ 40 000 = 3,10%. Варіант: 1 364 ÷ 40 000 = 3,41%. (3,41 − 3,10) ÷ 3,10 = 10% відносного приросту, або 0,31 пункту. Називай обидві цифри: «10%» саме по собі для половини кімнати звучить як 10 пунктів.'
      },
      fx: { ok: { insight: 4, dq: 2 }, fail: { insight: -4 } }
    },
    {
      type: 'triage',
      id: 's5',
      at: '11:45',
      comp: ['prioritisation', 'judgement'],
      traits: ['C', 'E'],
      text: {
        en: 'Five requests are open in your queue. Order them by what you take first, weighing value against urgency.',
        ua: 'У твоїй черзі п’ять запитів. Розстав їх у порядку, в якому візьмешся, зважуючи цінність проти терміновості.'
      },
      items: [
        {
          id: 'android',
          title: {
            en: 'Orders by app version for Vira',
            ua: 'Замовлення за версіями застосунку для Віри'
          },
          detail: {
            en: 'The Android team is waiting on your split to confirm the 5.8 bug before they cut a hotfix. 30 minutes of work.',
            ua: 'Android-команда чекає на твій розріз, щоб підтвердити баг у 5.8 перед хотфіксом. 30 хвилин роботи.'
          }
        },
        {
          id: 'board',
          title: { en: 'Weekend numbers for Natalia', ua: 'Цифри за вихідні для Наталії' },
          detail: {
            en: 'Board call at 15:00 today. She needs three lines and one chart; you already have the numbers.',
            ua: 'Дзвінок із правлінням о 15:00 сьогодні. Їй потрібні три рядки й один графік; цифри в тебе вже є.'
          }
        },
        {
          id: 'finance',
          title: { en: 'Revenue reconciliation for Larysa', ua: 'Звірка виручки для Лариси' },
          detail: {
            en: 'Monthly close is on Wednesday. Orders in the warehouse export and in analytics differ by 1.8%. Half a day of work.',
            ua: 'Місячне закриття в середу. Замовлення у вивантаженні зі складу й в аналітиці розходяться на 1,8%. Пів дня роботи.'
          }
        },
        {
          id: 'repeat',
          title: {
            en: 'Repeat-purchase deep dive for Oleh',
            ua: 'Глибокий аналіз повторних покупок для Олега'
          },
          detail: {
            en: 'Repeat rate fell through Q3 and nobody knows why. Planning is in two weeks. Two days of work.',
            ua: 'Частка повторних покупок падала весь третій квартал, і ніхто не знає чому. Планування за два тижні. Два дні роботи.'
          }
        },
        {
          id: 'creative',
          title: {
            en: 'Ad creative dashboard for Dmytro',
            ua: 'Дашборд рекламних креативів для Дмитра'
          },
          detail: {
            en: '"When you have time." The data already sits in the ads export; a day to build.',
            ua: '«Коли буде час». Дані вже є у вивантаженні з рекламного кабінету; день на побудову.'
          }
        }
      ],
      correctOrder: ['android', 'board', 'finance', 'repeat', 'creative'],
      explain: {
        en: 'A dev team waiting on you costs orders every hour, and the split takes 30 minutes. The board call has a hard time but the numbers are ready. Finance has a Wednesday deadline. The deep dive matters most in the long run but has two weeks of slack, and the nice-to-have dashboard goes last.',
        ua: 'Команда розробки, що чекає на тебе, коштує замовлень щогодини, а розріз — це 30 хвилин. У дзвінка з правлінням жорсткий час, але цифри готові. У фінансів дедлайн у середу. Глибокий аналіз найважливіший у довгу, але має два тижні запасу, а дашборд «коли буде час» іде останнім.'
      },
      fx: { ok: { stakeholders: 5 }, fail: { stakeholders: -4, energy: -4 } }
    },
    {
      type: 'spot',
      id: 's6',
      at: '13:00',
      comp: ['rigour', 'analysis'],
      traits: ['C', 'I'],
      text: {
        en: 'Before the board call, Natalia’s assistant sends the weekly summary that will go on the slide. It has 3 errors. Tap each one.',
        ua: 'Перед дзвінком із правлінням асистентка Наталії надсилає тижневий підсумок, який піде на слайд. У ньому 3 помилки. Натисни на кожну.'
      },
      mock: {
        kind: 'table',
        title: {
          en: 'Weekly summary, 29 Sep – 5 Oct (vs previous week)',
          ua: 'Тижневий підсумок, 29.09 – 05.10 (до попереднього тижня)'
        },
        blocks: [
          {
            id: 't1',
            kind: 'field',
            label: { en: 'Period', ua: 'Період' },
            value: '29.09 – 05.10'
          },
          {
            id: 't2',
            kind: 'field',
            label: { en: 'Compared with', ua: 'Порівняння з' },
            value: '08.09 – 14.09',
            issue: {
              en: 'The previous week is 22.09 – 28.09. This compares against a week three weeks back.',
              ua: 'Попередній тиждень — 22.09 – 28.09. Тут порівняння з тижнем тритижневої давності.'
            }
          },
          {
            id: 't3',
            kind: 'line',
            label: { en: 'Android orders', ua: 'Замовлення Android' },
            value: '6 120 · 38%'
          },
          {
            id: 't4',
            kind: 'line',
            label: { en: 'iOS orders', ua: 'Замовлення iOS' },
            value: '5 480 · 34%'
          },
          {
            id: 't5',
            kind: 'line',
            label: { en: 'Web orders', ua: 'Замовлення веб' },
            value: '4 500 · 28%'
          },
          {
            id: 't6',
            kind: 'total',
            label: { en: 'Total orders', ua: 'Разом замовлень' },
            value: '15 800',
            issue: {
              en: '6 120 + 5 480 + 4 500 = 16 100, not 15 800.',
              ua: '6 120 + 5 480 + 4 500 = 16 100, а не 15 800.'
            }
          },
          { id: 't7', kind: 'line', label: { en: 'Conversion', ua: 'Конверсія' }, value: '3.2%' },
          {
            id: 't8',
            kind: 'line',
            label: { en: 'Repeat-customer share', ua: 'Частка повторних клієнтів' },
            value: '104%',
            issue: {
              en: 'A share cannot exceed 100%. Most likely repeat orders were divided by customers, not by all orders.',
              ua: 'Частка не може перевищувати 100%. Найімовірніше, повторні замовлення поділили на клієнтів, а не на всі замовлення.'
            }
          },
          {
            id: 't9',
            kind: 'note',
            label: { en: 'Data refreshed', ua: 'Дані оновлено' },
            value: '06.10, 03:00'
          }
        ]
      },
      explain: {
        en: 'The comparison week is 08.09 – 14.09 instead of 22.09 – 28.09, so every "vs last week" delta is wrong. The platform rows add up to 16 100, not 15 800. And a 104% repeat share is a formula error: a share cannot pass 100.',
        ua: 'Тиждень порівняння — 08.09 – 14.09 замість 22.09 – 28.09, тож кожна дельта «до минулого тижня» хибна. Рядки платформ дають 16 100, а не 15 800. А 104% частки повторних — помилка формули: частка не може перевищити 100.'
      },
      fx: { ok: { dq: 7, stakeholders: 3 }, fail: { dq: -5 } }
    },
    {
      type: 'allocate',
      id: 's7',
      at: '13:45',
      comp: ['prioritisation', 'judgement'],
      traits: ['E', 'I'],
      text: {
        en: 'Natalia asks what you will do with the rest of the week. You have 100% of your time; split it.',
        ua: 'Наталія питає, на що піде решта тижня. У тебе 100% часу; розподіли його.'
      },
      buckets: [
        {
          id: 'adhoc',
          label: { en: 'Ad-hoc requests', ua: 'Разові запити' },
          hint: {
            en: '14 requests arrived last week; 9 of them were a chart someone could have pulled from the dashboard.',
            ua: 'Минулого тижня надійшло 14 запитів; 9 із них — графік, який можна було взяти з дашборда самостійно.'
          },
          best: 30
        },
        {
          id: 'dq',
          label: { en: 'Data quality', ua: 'Якість даних' },
          hint: {
            en: 'Since Friday 11% of Android events arrive without a version tag, the exact field the investigation needs.',
            ua: 'З п’ятниці 11% подій Android приходять без тегу версії — саме того поля, яке потрібне розслідуванню.'
          },
          best: 25
        },
        {
          id: 'automation',
          label: { en: 'Automation', ua: 'Автоматизація' },
          hint: {
            en: 'The Monday report takes four hours by hand every week.',
            ua: 'Понеділковий звіт щотижня забирає чотири години ручної роботи.'
          },
          best: 20
        },
        {
          id: 'deep',
          label: { en: 'Deep dives', ua: 'Глибокі аналізи' },
          hint: {
            en: 'The Android root cause and the Q3 repeat-purchase question are both still open.',
            ua: 'Першопричина падіння на Android і питання повторних покупок за третій квартал досі відкриті.'
          },
          best: 25
        }
      ],
      explain: {
        en: 'Requests will not stop, so they keep the largest slice, but a third less than last week once the dashboard-answerable ones are redirected. Data quality gets a quarter because the missing version tag blocks the investigation itself. Four hours of Monday reporting pay back the automation within a month, and the two deep dives are where the insight actually lives.',
        ua: 'Запити не зникнуть, тому вони отримують найбільшу частку, але на третину меншу, ніж минулого тижня, якщо перенаправити ті, на які відповідає дашборд. Якість даних — чверть, бо відсутній тег версії блокує саме розслідування. Чотири години понеділкового звіту окуплять автоматизацію за місяць, а два глибокі аналізи — там, де насправді живе інсайт.'
      },
      fx: { ok: { insight: 4, dq: 4 }, fail: { insight: -3, energy: -4 } }
    },
    {
      type: 'chat',
      id: 's8',
      at: '14:40',
      comp: ['communication', 'judgement'],
      traits: ['E', 'S'],
      messages: [
        {
          from: 'ceo',
          text: {
            en: 'Board call in 20 minutes. I need one number about the weekend. One. They will not read a dashboard.',
            ua: 'Дзвінок із правлінням за 20 хвилин. Мені потрібна одна цифра про вихідні. Одна. Дашборд вони читати не будуть.'
          }
        }
      ],
      prompt: { en: 'What do you send Natalia?', ua: 'Що надсилаєш Наталії?' },
      options: [
        {
          text: {
            en: '"Weekend orders −10% week on week, almost all of it Android (−22%) after Friday’s release; iOS and web flat; hotfix ships tonight." One number, one cause, one fix.',
            ua: '«Замовлення −10% до минулого тижня, майже все — Android (−22%) після п’ятничного релізу; iOS і веб рівно; хотфікс сьогодні ввечері». Одна цифра, причина і рішення.'
          },
          q: 'best',
          fx: { stakeholders: 6, insight: 3 },
          fb: {
            en: 'The board hears a number, a cause and that it is handled, in one breath. That is the sentence Natalia would otherwise have had to build herself from your dashboard.',
            ua: 'Правління чує цифру, причину і що все під контролем, на одному диханні. Це речення Наталія інакше мала б сама зібрати з твого дашборда.'
          }
        },
        {
          text: {
            en: 'Send the dashboard link with the weekend view pinned and the three key charts marked, so she can pick whichever number fits the conversation best.',
            ua: 'Надіслати посилання на дашборд із закріпленим видом за вихідні й трьома позначеними ключовими графіками, щоб вона обрала ту цифру, яка найкраще пасує розмові.'
          },
          q: 'ok',
          fx: { stakeholders: -3, energy: 2 },
          fb: {
            en: 'She said "one number" because she has no time to pick. You handed the analysis back to the person who asked for it.',
            ua: 'Вона сказала «одна цифра», бо не має часу обирати. Ти повернув аналіз тій, хто про нього просила.'
          }
        },
        {
          text: {
            en: '"Conversion was 2.75%." It is accurate, it is the number you computed first thing this morning, and one number is exactly what she asked for.',
            ua: '«Конверсія була 2,75%». Це точно, це саме та цифра, яку ти порахував першою сьогодні зранку, і одна цифра — саме те, про що вона просила.'
          },
          q: 'bad',
          fx: { stakeholders: -5 },
          fb: {
            en: 'Accurate and meaningless to a board: 2.75% of what, compared with what, and so what? A number without a comparison and a cause is not an answer.',
            ua: 'Точно й безглуздо для правління: 2,75% від чого, порівняно з чим і що з того? Цифра без порівняння й причини — не відповідь.'
          }
        },
        {
          text: {
            en: 'Reply that the data is not fully clean yet, the version tags are missing on 11% of events, and you would rather give her a solid number tomorrow.',
            ua: 'Відповісти, що дані ще не повністю чисті, на 11% подій бракує тегів версії, і ти краще даси їй надійну цифру завтра.'
          },
          q: 'bad',
          fx: { stakeholders: -7, dq: 2 },
          fb: {
            en: 'The board call is in 20 minutes, not tomorrow. "−10%, mostly Android" is solid even with 11% missing tags; perfect data is not the job, a decision is.',
            ua: 'Дзвінок із правлінням за 20 хвилин, а не завтра. «−10%, переважно Android» — надійно навіть із 11% відсутніх тегів; робота — не ідеальні дані, а рішення.'
          }
        }
      ],
      principle: {
        en: 'One number, one comparison, one cause.',
        ua: 'Одна цифра, одне порівняння, одна причина.'
      }
    }
  ],
  verdict: {
    bands: [
      {
        min: 0.8,
        title: {
          en: 'You would be the analyst the CEO texts first',
          ua: 'Ти був би аналітиком, якому CEO пише першому'
        },
        text: {
          en: 'You segmented before you blamed, refused a chart that lied and gave the board a number with a cause attached.',
          ua: 'Ти сегментував, перш ніж звинувачувати, відмовився від графіка, що бреше, і дав правлінню цифру з причиною.'
        }
      },
      {
        min: 0.6,
        title: {
          en: 'Sharp with numbers, still soft with people',
          ua: 'Сильний у цифрах, ще м’який із людьми'
        },
        text: {
          en: 'The analysis was right; the misses were in what you sent to whom, and how much of it.',
          ua: 'Аналіз був правильний; промахи — у тому, що й кому ти надсилав і в якому обсязі.'
        }
      },
      {
        min: 0.4,
        title: {
          en: 'You compute well and conclude early',
          ua: 'Ти добре рахуєш і зарано робиш висновки'
        },
        text: {
          en: 'Several calls jumped from a correlation to a cause. Re-read the feedback on the Android drop and the marketing chart.',
          ua: 'Кілька рішень перескочили від кореляції до причини. Перечитай фідбек до падіння на Android і до графіка для маркетингу.'
        }
      },
      {
        min: 0,
        title: {
          en: 'This Monday would have ended with the wrong chart on the board slide',
          ua: 'Цей понеділок закінчився б хибним графіком на слайді для правління'
        },
        text: {
          en: 'Many choices optimised for pleasing the asker. The job is the opposite: say what the data shows, in a sentence they can act on.',
          ua: 'Багато рішень були про те, щоб догодити тому, хто питає. Робота ж навпаки: сказати, що показують дані, одним реченням, за яким можна діяти.'
        }
      }
    ],
    reality: [
      {
        en: 'About half the week is cleaning and joining data; the analysis people imagine is maybe a fifth.',
        ua: 'Близько половини тижня — чистити й з’єднувати дані; аналіз, який усі собі уявляють, — хіба що п’ята частина.'
      },
      {
        en: 'Ten to fifteen requests a week arrive as a "quick question", and most are a chart that already exists.',
        ua: 'Десять-п’ятнадцять запитів на тиждень приходять як «швидке питання», і більшість із них — графік, який уже існує.'
      },
      {
        en: 'Once or twice a month someone asks you to confirm a conclusion they already made. Saying no politely is a core skill.',
        ua: 'Раз-два на місяць хтось просить підтвердити висновок, який уже зробив. Увічливо відмовити — базова навичка.'
      }
    ]
  }
};
